import axios from 'axios';
import Qs from 'qs';
import cookie from './cookie';
import httpErrorHandler from './httpErrorHandler';

const isDev = process.env.NODE_ENV === 'development';

const baseAPI =  process.env.BASE_API;

// console.log("process.env:",process.env)

const instance = axios.create({
  baseURL: baseAPI,
  headers: {
    'x-platform': 4,
    token: cookie.getItem('bfe_t'),
  }
});

instance.interceptors.request.use(config => {
  // 也可以在这里给请求添加token之类的字段
  // config.data = Qs.stringify(config.data, {arrayFormat: 'repeat', allowDots: true});
  config.headers["token"] = cookie.getItem('bfe_t');
  return config;
}, err => {
  return Promise.reject(err);
});

instance.interceptors.response.use(response=>{
  return response.data
},httpErrorHandler);

/**
 * 封装后的axios post方法
 *
 * @param {string} url 请求路径
 * @param {object} option 请求参数
 * @param {object} [config] 特殊配置项（选填）
 * @returns
 */
export function post(url, option, config = {}) {
  instance.defaults.headers.post['Content-Type'] = "application/json;charset=UTF-8";
  return instance.post(url, option, config)
}

/**
 * 封装后的axios post方法
 *
 * @param {string} url 请求路径
 * @param {object} option 请求参数
 * @param {object} [config] 特殊配置项（选填）
 * @returns
 */
export function postForm(url, option, config = {}) {
  instance.defaults.headers.post['Content-Type'] = "application/x-www-form-urlencoded;charset=UTF-8";
  option = Qs.stringify(option, {arrayFormat: 'repeat', allowDots: true});
  return instance.post(url, option, config)
}

/**
 * 封装后的axios get方法
 *
 * @param {string} url 请求路径
 * @param {object} option 请求参数
 * @param {object} [config] 特殊配置项（选填）
 * @returns
 */
export function get(url, option, config = {}) {
  return instance.get(url, { params: option }, config)
}



// WEBPACK FOOTER //
// ./src/assets/utils/ajax.js